import React from 'react';
import { useIntl } from 'react-intl';
import { AttachmentsResponse, Text } from '../../../../../../UILibrary';
import { definedTranslation } from '../../i18n';

type PdfContentProps = {
  selectedFile: AttachmentsResponse['items'][number] | null;
};

export function PdfContent({ selectedFile }: PdfContentProps) {
  const intl = useIntl();
  const iframeRef = React.useRef<HTMLIFrameElement>(null);

  if (!selectedFile) {
    return (
      <Text className="text-center text-[#86868B] max-w-[350px]">
        {intl?.formatMessage(
          definedTranslation.previewFiles.unselectedFileLabel,
        )}
      </Text>
    );
  }

  return (
    <div className="relative w-full h-full m-0 p-0 text-[16px] text-center overflow-auto">
      <div
        className="absolute top-0 h-[60px] z-[999] bg-[#f5f5f7] w-full"
        style={{
          backgroundColor: '#f5f5f7',
        }}
      />
      <iframe
        ref={iframeRef}
        className="border-0"
        src={selectedFile?.filename}
        width="100%"
        height="100%"
      />
    </div>
  );
}
